import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { SecondaryButton, DefaultButton } from '@/components/ui/Button';

interface ConfirmDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ConfirmDeleteModal({ open, onClose, onConfirm }: Readonly<ConfirmDeleteModalProps>) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="bg-white rounded-lg p-6 max-w-sm w-full">
          <DialogTitle className="text-lg font-semibold">Konfirmasi Penghapusan</DialogTitle>
          <p className="mt-2 text-sm text-gray-600">
            Apakah Anda yakin ingin menghapus item ini? Tindakan ini tidak dapat dibatalkan.
          </p>
          <div className="mt-4 flex justify-end gap-2">
            <SecondaryButton onClick={onClose}>Batal</SecondaryButton>
            <DefaultButton
              onClick={onConfirm}
              className="!bg-red-500 hover:!bg-red-600 text-white rounded-lg px-3 py-1 text-sm"
            >
              Hapus
            </DefaultButton>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
